// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17gs6","index":"styles_index__2-mTI"};